import { ILSInput } from '@common/components';
import { FC } from 'react';
import { InputProps } from 'antd';

// Компонент содержащий в себе фильтры
export const ILSDemandInputComponent: FC<InputProps> = (props) => {
  return <ILSInput {...props} />;
};
